// frontend/src/context/AppProviders.jsx
import React, { useState } from "react";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

import { AuthProvider } from "./AuthContext";
import { SubscriptionProvider } from "./SubscriptionContext";
import { CompanyProvider } from "./CompanyContext";
import { ThemeProvider } from "./ThemeContext";

function createSignalIQQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 30,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        retry: 1,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export function AppProviders({ children }) {
  const [queryClient] = useState(() => createSignalIQQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <SubscriptionProvider>
            <CompanyProvider>{children}</CompanyProvider>
          </SubscriptionProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default AppProviders;